import { render } from "./AttendancePDFView.vue?vue&type=template&id=24b190df&scoped=true"
import script from "./AttendancePDFView.vue?vue&type=script&lang=js"
export * from "./AttendancePDFView.vue?vue&type=script&lang=js"

import "./AttendancePDFView.vue?vue&type=style&index=0&id=24b190df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b190df"]])

export default __exports__